<div
    class="agpr-monitoring-brand-card agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-monitoring-brand-card--with-border': !hideBorder,
    }"
>
    <div
        class="agpr-monitoring-brand-card-summary"
    >
        @let logoValue = logo[0];
        @if(logoValue?.url && !logoValue?.hasError) {
            <div class="agpr-monitoring-brand-card-logoPlaceholder">
                <img
                    [src]="logoValue.url"
                    [alt]="logoValue.altText"
                    (load)="getImageDimensions($event)"
                    (error)="logoValue.hasError = true"
                />
            </div>
        } @else {
            <div
                class="agpr-monitoring-brand-card-logoPlaceholder"
                [style.background-color]="color"
            >
                <span>{{ placeholderText }}</span>
            </div>
        }
        <div class="agpr-monitoring-brand-card-name">
            @if (isEditingName) {
                <agpr-text-input
                    [id]="id + '_nameInput'"
                    class="agpr-monitoring-brand-card-nameInput"
                    [ariaLabel]="'Briefing.onlineBriefing.settings.competitor.name'"
                    [placeholder]="'Briefing.onlineBriefing.settings.competitorName.placeholder'"
                    [(ngModel)]="nameInputValue"
                    (blur)="doneEditingName()"
                    [bottomMargin]="false"
                ></agpr-text-input>
            } @else {
                <span
                    class="agpr-monitoring-brand-card-nameText"
                    [agprTooltip]="name"
                    tooltipPosition="top"
                >
                    {{ name }}
                </span>
            }
            @if (!isEditingName) {
                <agpr-button
                    [id]="id + '_summary_editButton'"
                    class="agpr-monitoring-brand-card-summary-editButton"
                    icon="fa-regular fa-duotone fa-pen"
                    [style]="buttonTypesEnum.icon"
                    tooltip="Briefing.onlineBriefing.settings.competitor.name.edit"
                    tooltipPosition="top"
                    (click)="isEditingName = true; nameInputValue = name;"
                ></agpr-button>
            }
        </div>
    </div>
    @if (hasNameError) {
        <agpr-form-message [marginBottom]="0">
            {{ 'Briefing.onlineBriefing.settings.competitor.name.required' | localize }}
        </agpr-form-message>
    }
    @if (showDataSourceField) {
        <div
            class="agpr-monitoring-brand-card-content"
            [@cardState] = "{
                value: cardState ? 'collapsed' : 'expanded',
            }"
        >
            @if (hasDataSourceError) {
                <agpr-form-message [marginBottom]="0">
                    {{ 'Briefing.onlineBriefing.settings.competitor.dataSource.error' | localize }}
                </agpr-form-message>
            }
        </div>
    }
    <div
        class="agpr-monitoring-brand-card-content"
        [@cardState] = "{ value: cardState ? 'expanded' : 'collapsed' }"
    >
        <div class="agpr-monitoring-brand-card-brandField">
            <agpr-autocomplete
                [id]="id + '_brandAutocomplete'"
                class="agpr-monitoring-brand-card-brandAutocomplete"
                [label]="'Briefing.onlineBriefing.settings.competitor.brand'"
                placeholder="Briefing.onlineBriefing.settings.competitor.brand.placeholder"
                tooltipPosition="top"
                [dropdown]="true"
                [suggestions]="brandList$"
                [customOptions]="brandAutocompleteCustomOptions"
                labelField="name"
                [(ngModel)]="brand"
                (ngModelChange)="selectBrand($event)"
                [clearOnBlur]="false"
            ></agpr-autocomplete>
            <agpr-button
                [id]="id + '_brandPicker_manageButton'"
                class='agpr-monitoring-brand-card-brandPicker-manageButton'
                [style]="buttonTypesEnum.block"
                icon='fa-regular fa-duotone fa-gear'
                tooltip="Common.brandIdentity.manageDialog.heading"
                tooltipPosition="top"
                (click)="openManageBrandsDialog()"
            ></agpr-button>
        </div>

        @if (showLogoField) {
            <div class="agpr-monitoring-brand-card-logoField">
                <agpr-multi-content-library-panel
                    [id]="id + '_logoPicker'"
                    class="agpr-monitoring-brand-card-logoPicker"
                    [field]="logoField"
                    [(ngModel)]="logo"
                    (changes)="logoChanged($event)"
                ></agpr-multi-content-library-panel>
            </div>
        }

        @if (showDataSourceField) {
            <ng-container *ngTemplateOutlet="dataSourcePicker"></ng-container>
        }

        <div class="agpr-monitoring-brand-card-colorField">
            <div class="agpr-monitoring-brand-card-colorLabel">
                {{ 'Briefing.onlineBriefing.settings.competitor.color' | localize}}
            </div>
            <agpr-color-picker-field
                [id]="id + '_colorPicker'"
                class="agpr-monitoring-brand-card-colorPicker"
                [brandId]="brand?.id"
                [config]="{
                    showRecentColors: showRecentColors
                }"
                [(ngModel)]="color"
                (ngModelChange)="colorChanged($event)"
            ></agpr-color-picker-field>
        </div>
    </div>

    <div class="agpr-monitoring-brand-card-toggleButton">
        @let label = toggleButtonLabel ? toggleButtonLabel
            :  cardState ? 'Core.collapse' : 'Core.expand';
        <agpr-button
            [id]="id + '_toggleButton'"
            class="agpr-monitoring-brand-card-toggleButton"
            [style]="buttonTypesEnum.link"
            [ariaLabel]="label"
            [tooltip]="label"
            [tooltipPosition]="'left'"
            [expanded]="cardState"
            (click)="cardState = !cardState"
        >
            <span
                class="fa-solid agpr-monitoring-brand-card-toggleButton-icon"
                aria-hidden="true"
                [ngClass]="{
                    'fa-angle-down': cardState,
                    'fa-angle-up': !cardState
                }"
            ></span>
        </agpr-button>
    </div>
</div>

<ng-template #dataSourcePicker>
    <agpr-monitoring-source-picker-with-facet-and-search-field
        [id]="id + '_dataSourcePicker'"
        class="agpr-monitoring-brand-card-card-dataSourcePicker"
        [field]="dataSourceField"
        [value]="dataSource"
        [isGlobalDateRange]="isGlobalDateRange"
        [monthlyDateRange]="monthlyConfigs?.monthlyDateRange"
        [monthlySettings]="monthlyConfigs?.monthlySettings"
        [restrictMonthToMostRecent]="monthlyConfigs?.restrictMonthToMostRecent"
        [quarterlyDateRange]="quarterlyConfigs?.quarterlyDateRange"
        [quarterlySettings]="quarterlyConfigs?.quarterlySettings"
        [restrictQuarterToMostRecent]="quarterlyConfigs?.restrictQuarterToMostRecent"
        (changes)="dataSourceChanged($event)"
        [showHiddenOption]="true"
        [showErrors]="hasDataSourceError"
    ></agpr-monitoring-source-picker-with-facet-and-search-field>
</ng-template>
